const URL_BASE=process.env.REACT_APP_API;

export const URL_HOTMERS_LIST=`${URL_BASE}/hotmers`;